import { DatePipe } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import * as moment from 'moment';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { AddressDTO } from 'src/app/demo/model/AddressDTO';
import { InvoiceDTO } from 'src/app/demo/model/InvoiceDTO';
import { InvoiceDetailsDTO } from 'src/app/demo/model/InvoiceDetailsDTO';
import { SchoolDTO } from 'src/app/demo/model/SchoolDTO';
import { StudentDTO } from 'src/app/demo/model/StudentDTO';
import { LookupService } from 'src/app/demo/service/lookup.service';
import { OperationService } from 'src/app/demo/service/operation.service';
import { Common } from 'src/app/demo/utils/common';
import { profielBackgroundColor } from '../../constants/profielBackgroundColor';
import html2pdf from 'html2pdf.js';

@Component({
  selector: 'app-send-invoice',
  templateUrl: './send-invoice.component.html',
  styleUrls: ['./send-invoice.component.scss']
})
export class SendInvoiceComponent implements OnInit {
  @ViewChild('printContent') printContent!: ElementRef;
  showSchoolLogo: boolean = true;

  invoiceData: DynamicDialogConfig<any>;
  invoiceForm!: InvoiceDTO;
  search: any = {};
  pageContext = {
    page: 0,
    previousPage: 0,
    itemsPerPage: 20,
    totalItems: 0,
    sort: 'id,desc',
  };
  invoiceDetails: InvoiceDetailsDTO[] = [];
  submitForm: boolean = false;
  schoolDetails !: SchoolDTO;
  addressDetails !: AddressDTO;
  studentId: any;
  studentDetails: any;
  constructor(
    public config: DynamicDialogConfig,
    private formBuilder: FormBuilder,
    public dialogService: DialogService,
    public ref: DynamicDialogRef,
    private lookupService: LookupService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private sanitizer: DomSanitizer,
    private operationService: OperationService,
    private datePipe: DatePipe,
    private elementRef: ElementRef
  ) {
    this.invoiceData = this.config;
    this.invoiceForm = this.config.data.invoiceObj.invoice[0] || {};
    this.studentId = this.invoiceForm.studentId;
    this.schoolDetails = this.config.data.schoolDetails;
    this.addressDetails = this.config.data.address;
    this.fetchProfileImage(this.schoolDetails);
  }

  ngOnInit() {
    this.search = {};
    this.search['refTable.equals'] = 'Invoice';
    this.search['refTableId.equals'] = this.invoiceForm.id;
    this.lookupService.queryInvoiceDetails(this.search).subscribe((res: HttpResponse<InvoiceDetailsDTO[]>) => {
      this.invoiceDetails = res.body ?? [];
    })
    this.lookupService
      .getStudentById(this.studentId)
      .subscribe((res: HttpResponse<StudentDTO>) => {
        this.studentDetails = res.body ?? {};
        if (this.studentDetails.photoUuid) {
          this.lookupService.queryDocumentByPhotoUid(this.studentDetails.photoUuid).subscribe((response: HttpResponse<Blob>) => {
            const body = response?.body;
            if (body) {
              const url = this.createImgFromBuffer(body);
              this.studentDetails.profileimg = url;
            }
          });
        } else {
          this.studentDetails.profileimg = undefined;
        }
      });
  }

    // sachin start
    getSchoolInitials(name: string | undefined): string {
        if (!name) return '';
        const words = name.trim().split(/[-\s]+/); // Split by hyphens or spaces
        const firstLetter = words[0]?.[0]?.toUpperCase() || ''; // Get the first letter of the first word
        const secondLetter = words[1]?.[0]?.toUpperCase() || '';
        return `${firstLetter}${secondLetter}`.trim();
    }
    // end here

  // printInvoice(): void {
  //   window.print();
  // }

  //   printInvoice(): void {
  //     // Remove elements with class 'no-print' before printing
  //     const elementsToHide = document.querySelectorAll('.no-print');
  //     elementsToHide.forEach(element => {
  //         element.remove();
  //     });

  //     // Hide PrimeNG Dialog header for printing
  //     const dialogHeader = document.querySelector('.p-dialog-header');

  //     if (dialogHeader) {
  //         dialogHeader.classList.add('no-print');
  //     }

  //     // Perform the printing
  //     window.print();

  //     // Reinsert the removed elements back into the DOM after a short delay
  //     setTimeout(() => {
  //         elementsToHide.forEach(element => {
  //             document.body.appendChild(element);
  //         });
  //         // Remove no-print class from PrimeNG Dialog header after printing
  //         if (dialogHeader) {
  //             dialogHeader.classList.remove('no-print');
  //         }
  //     }, 1000); // Adjust the delay as needed (in milliseconds)
  // }

  printInvoice(isView: boolean = false) {
    const element = this.printContent.nativeElement;
    const clonedElement = element.cloneNode(true) as HTMLElement;
  
    // Remove no-print elements
    clonedElement.querySelectorAll('.no-print').forEach(el => el.remove());
  
    // Remove dialog header if present
    const dialogHeader = clonedElement.querySelector('.p-dialog-header');
    if (dialogHeader) {
      dialogHeader.remove();
    }
  
    const options = {
      margin: 0.5,
      filename: `invoice_${this.invoiceForm.invoiceNumber || 'invoice'}.pdf`,
      image: { type: 'jpeg' as 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true, allowTaint: true },
      jsPDF: { unit: 'in' as 'in', format: 'letter' as 'letter', orientation: 'portrait' as 'portrait' }
    };
  
    const worker = html2pdf().set(options).from(clonedElement);
  
    if (isView) {
      // ✅ VIEW → open in new tab (no download)
      worker.toPdf().get('pdf').then((pdf: any) => {
        const blobUrl = pdf.output('bloburl');
        window.open(blobUrl, '_blank');
      });
    } else {
      // ✅ DOWNLOAD → force download
      worker.save();
    }
  }
  

  downloadFile(res: any, fileName: string, format: string) {
    const a = document.createElement('a');
    let header: any =
      res.headers.get('Content-Type') != null
        ? res.headers.get('Content-Type')
        : '';
    a.href = URL.createObjectURL(new Blob([res.body], { type: header }));
    a.download =
      fileName + moment().format('YYYYMMDD_HHmmss') + `.${format}`;
    document.body.appendChild(a);
    a.click();
  }

  restoreRemovedElements() {
    const selectors = ['.no-print', '.p-dialog-title', '.p-dialog-header-icons'];

    selectors.forEach(selector => {
      const elements = document.querySelectorAll(selector);
      elements.forEach(element => {
        element.classList.remove('hidden');
      });
    });
  }

  sendInvoice() {
    this.submitForm = true;
    const innerObj = this.invoiceData.data.invoiceObj.invoice[0];
    const obj: InvoiceDTO = {
      ...innerObj,
      sentDate: Common.momentCurrentDate(),
      invoiceStatus: 'Sent',
    };
    this.operationService
      .updateInvoice(obj)
      .subscribe(
        async (res: HttpResponse<InvoiceDTO>) => {
          const tmep = res.body;
          if (tmep && tmep.invoiceStatus == 'Sent') {
            await this.operationService.sendInvoice(tmep).toPromise();
          }
          this.submitForm = false;
          const message = {
            severity: 'success',
            life: 3000,
            summary: 'Success',
            detail: 'Invoice sent successfully.',
          }
          this.ref.close(message);
        },
        (error) => {
          this.submitForm = false;
          this.messageService.add({
            severity: 'error',
            life: 3000,
      summary: error.error?.title || 'Error',
      detail: error.error?.detail || error.error?.message || error?.message || 'An error occurred'
          });
        }
      );
  }

  onClose() {
    this.ref.close();
  }

  getInitials(name: string): string {
    const words = name?.trim().split(/[-\s]+/); // Split by hyphens or spaces
    const firstLetter = words[0][0]?.toUpperCase(); // Get the first letter of the first word
    const secondLetter = words[1]?.[0]?.toUpperCase() || ''; // Get the first letter of the second word (if it exists)
    return `${firstLetter}${secondLetter}`.trim(); // Concatenate and trim
  }

  getBackgroundColor(roomId: number): string {
    if (!roomId) return profielBackgroundColor[0];
    const index = (roomId - 1) % profielBackgroundColor.length;
    return profielBackgroundColor[index];
  }

  fetchProfileImage(school: SchoolDTO) {
    if (school.logo != undefined) {
      this.lookupService.queryDocumentByPhotoUid(school.logo).subscribe((response: HttpResponse<Blob>) => {
        const body = response?.body;
        if (body) {
          const url = this.createImgFromBuffer(body);
          school.profileimg = url;
        }
      });
    } else {
      school.profileimg = undefined;
    }
  }

  createImgFromBuffer(blob: Blob) {
    const url = URL.createObjectURL(blob);
    return url;
  }
  onSchoolLogoError() {
    this.showSchoolLogo = false;
}
}
